import { isOnThisPage } from "@/pages/PageHelper";
import * as MiscUtils from "@/utilities/MiscUtils";
import { getWordCount } from "@/validation/WordCountValidation";

const PATH: string = "/scholarships/apply";

/** A reference to the career plans field */
let careerPlansField: HTMLTextAreaElement | null = null;

/** A reference to the career plans word count element */
let careerPlansWordCountElement: HTMLElement | null = null;

export function tryInitScholarshipApplyPageScript()
{
    if (!isOnThisPage(PATH))
        return;

    careerPlansField = document.getElementById("CareerPlans") as HTMLTextAreaElement;
    careerPlansWordCountElement = document.getElementById("careerPlansWordCount");

    if (careerPlansField != null)
    {
        const onCareerPlansChanged: (event: InputEvent) => void = MiscUtils.createDebouncingFunction(onCareerPlansChangedDebounced, 300);

        //When typing in the CareerPlans field, validate it after a 300 ms delay
        careerPlansField.addEventListener("input", event => onCareerPlansChanged(event));
    }

    updateWordCountDisplay();
}

function onCareerPlansChangedDebounced(event: InputEvent)
{
    //Update the word count display
    if (careerPlansWordCountElement != null && careerPlansField != null && event.target === careerPlansField)
        updateWordCountDisplay();
}

function getWordCountConstraints(): { min?: number, max?: number }
{
    let min: number | undefined = undefined;
    let max: number | undefined = undefined;

    if (careerPlansField != null)
    {
        const rawMin: string | undefined = careerPlansField.dataset["valWordcountMin"];
        const rawMax: string | undefined = careerPlansField.dataset["valWordcountMax"];

        min = rawMin != undefined ? +rawMin : undefined;
        max = rawMax != undefined ? +rawMax : undefined;
    }

    return { min, max };
}

function updateWordCountDisplay()
{
    if (careerPlansWordCountElement != null)
    {
        if (careerPlansField != null)
        {
            const text: string = careerPlansField.value;
            const wordCount: number = getWordCount(text);

            const { min, max } = getWordCountConstraints();

            if (max != undefined)
                careerPlansWordCountElement.innerText = `${wordCount.toLocaleString()} / ${max.toLocaleString() } words`;
            else
                careerPlansWordCountElement.innerText = `${wordCount.toLocaleString() } words`;
        }
        else
        {
            careerPlansWordCountElement.innerText = "CareerPlans field missing";
        }
    }
}
